/**
 * Какой это продукт: приложение владельца или приложение кассира.
 *
 * ОДИН ИСХОДНИК, ДВЕ УПАКОВКИ. ТЗ (docs/03, раздел 10) прямо против третьего
 * фронта: «бэк-офис адаптивный», кассир видит то же приложение с ролью
 * CASHIER. Здесь ничего этому не противоречит — код общий, различается только
 * то, каким приложение выходит на экран телефона.
 *
 * Различие нужно затем, что иконка на телефоне обещает конкретную вещь.
 * Приложение с названием «Касса», открывающее отчёты по выручке, — сломанное
 * обещание, даже если человек имеет право эти отчёты видеть.
 *
 * ЭТО НЕ ЗАЩИТА. Права живут на сервере: `AdminController` закрыт для роли
 * CASHIER, и по прямой ссылке кассир получит отказ независимо от упаковки.
 * Здесь решается только вопрос «что показывать», а не «что разрешено».
 */

export type Product = 'OWNER' | 'CASHIER'

/** В вебе продукт всегда «владелец»: там бэк-офис целиком. */
export const PRODUCT: Product = import.meta.env.VITE_APP_ROLE === 'cashier' ? 'CASHIER' : 'OWNER'

export const isCashierApp = (): boolean => PRODUCT === 'CASHIER'
